// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__QryOL","col":"Table_col__derxb","fulfillmentStatus":"Table_fulfillmentStatus__1rOUt","emailCol":"Table_emailCol__3Jm0K"};